/* eslint-disable no-undef */
import React, { useRef, useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { IoMdCloudDownload } from 'react-icons/io';
import { IoMdCloudUpload } from 'react-icons/io';
import { API } from '../../apis/api';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Icon,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';
import defaultStyles from './DayWisePlanDataTable.module.css';
import jlrStyles from './DayWisePlanDataTableJlr.module.css';
import { CommentForm, AddVcForm, AddEmergencyAsnForm } from '..';
import {
  isPositiveIntegerOrZero,
  getDatesForRange,
  isSunday,
  callFunctionConditionallyWithWarningCurry,
  isQuantityValid,
  setStylesAccordingToPlant,
} from '../../utils/utils';
import {
  filterByVcCurry,
  getCellStyle,
  getSelectedOptionalColumns,
} from '../../utils/tableUtils';
import {
  API_RESOURCE_URLS,
  SORT_STATE,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  DATE_FORMAT,
  USER_OPERATIONS,
  JLR_PLANT,
  APPLICATION_VARIANTS,
} from '../../constants';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import SaveFloppySvg from '../../icons/save_floppy.svg';
import SaveFloppyGreenSvg from '../../icons/save_floppy_green.svg';
import CloseSvg from '../../icons/close.svg';
import {
  SortAscendingIcon,
  SortDescendingIcon,
  EditIcon,
  FileIcon,
} from '../../icons';
import { makeStyles } from '@material-ui/core/styles';
import { Popover } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { MdClose } from 'react-icons/md';
import HeaderSearchBar from '../HeaderSearchBar.js/HeaderSearchBar';
import AuthEnabledButton from '../AuthEnabledButton/AuthEnabledButton';
import { buildErrorMessage } from '../../apis/calls';
import VcWithPartialDataInfo from '../VcWithPartialDataInfo/VcWithPartialDataInfo';
import config from '../../config/config';
import AddVcFormMes4 from '../AddVcFormMes4/AddVcFormMes4';
import CommentFormMes4 from '../CommentFormMes4/CommentFormMes4';
import AddEmergencyAsnFormMes4 from '../AddEmergencyAsnFormMes4/AddEmergencyAsnFormMes4';
import EmergencyWarningDialog from '../EmergencyWarningDialog/EmergencyWarningDialog';


const DayWisePlanDataTable = ({
  planData,
  optionalColumns,
  selectedOptionalCols,
  startEditing,
  stopEditing,
  editActiveRowIndex,
  lastAsnGeneratedDate,
  updateRows,
  plant,
  plantName,
  line,
  lineName,
  
}) => {
  const { showPopup,showError ,showInternalError ,showLoading, } = usePopupManager();
  const ROWS_PER_PAGE = 10;
  const { APPLICATION_VARIANT } = config;
  const [selectedPlant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);
  const [plants] = usePlantAndLinesStore().plantState;
  const [lines] = usePlantAndLinesStore().lineState;
  const [shopId, setShopId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [FileName, setFileName] = useState(null);


  const loadShopIdForSelectedLine = async lineId => {
    try {
      const response = await API.get(
        API_RESOURCE_URLS.lineDetailsByLineId(lineId), // TODO: get from planning instead of digital twin service
      );
      const lineDetails = response.data;
      setShopId(lineDetails.shop?.id);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setShopId(null);
    }
  };

  const SelectAddTypeDialog = ({
    open,
    handleClose,
    openAddVcForm,
    openAddEmergencyAsnForm,
    lastAsnGeneratedDate,
  }) => {
    const handleOpenForm = fn => {
      fn();
      handleClose();
    };

    const isEmergencyAsnDisabled =
      !lastAsnGeneratedDate || lastAsnGeneratedDate.isBefore(moment(), 'day');

    return (
      <Dialog
        open={open}
        className={styles.dialogContainer}
        classes={{
          paper: APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT ? styles.dialogBoxMes4Ev : styles.dialogBox,
        }}
      >
        <DialogTitle>
          <span className={styles.title}>
            <FileIcon className={styles.icfail} />
            <span className={styles.txt}>Plan Revision</span>
          </span>
          <MdClose
            size="13px"
            className={styles.cancelIconDiag}
            onClick={handleClose}
            data-testid="close-icon"
          />{' '}
        </DialogTitle>
        <DialogContent className={styles.content}>          
          <Button
            startIcon={<AddCircleIcon />}
            className={clsx(styles.addButton, styles.addVcBtn)}
            onClick={() => handleOpenForm(openAddVcForm)}
          >
            Add VC
          </Button>
          <Button
            disabledHelperText="Use 'Generate ASN' feature to create new ASNs for production"
            startIcon={<AddCircleIcon className={styles.secondIcon} />}
            className={clsx(
              styles.addButton,
              styles.addAsnBtn,
              isEmergencyAsnDisabled && styles.noShadow,
            )}
            onClick={() => handleOpenForm(openAddEmergencyAsnForm)}
            disabled={isEmergencyAsnDisabled}
          >
            Emergency ASN
          </Button>                    
        </DialogContent>
        {APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT ?
          <>
            <DialogTitle>
              <span className={styles.title}>
                <span className={styles.emergencyTxt}>Bulk Upload (Emergency)</span>
              </span>
              <MdClose
                size="13px"
                className={styles.cancelIconDiag}
                onClick={handleClose}
                data-testid="close-icon"
              />{' '}
            </DialogTitle>
            <DialogContent className={styles.content}>        
              <Button
                    className={styles.downloadTemplateButton}
                    onClick={handleDownloadTemplateButtonClick}                
              >
                    <IoMdCloudDownload className={styles.downloadIcon} />

                    <span className={styles.label}>
                      <span className={styles.mainText}>
                        Template <sup>**</sup>
                      </span>
                      <span className={styles.subText}>(Excel file)</span>
                    </span>
              </Button>
              <Button className={styles.uploadCsvButton}>
                    <IoMdCloudUpload className={styles.uploadCsvIcon} />
                    <span className={styles.label}>
                      <label className={styles.upTxt} htmlFor="upload-Excel">
                        Upload plan
                      </label>
                      <label className={styles.subText}>(Excel file)</label>
                    </span>
                    <input
                      className={styles.input}
                      type="file"
                      id="upload-csv"
                      accept=".xlsx, .xls"
                      onClick={e => e.stopPropagation()}
                      onChange={e => {
                        handleEmergencyFileUpload(e);
                        handleClose(); // Close the dialog box after handling the file upload
                      }}
                    />
              </Button>                              
            </DialogContent>      
          </> : null
        }
    </Dialog>
    );
  };

  const getStickyStyle = idx => {
    const styleClasses = [
      styles.firstCol,
      styles.secondCol,
      styles.thirdCol,
      styles.fourthCol,
    ];
    return styleClasses[idx];
  };

  const SummaryCell = ({ children, colNo, ...rest }) => {
    const stickyColStyle = getStickyStyle(colNo);
    return (
      <TableCell
        className={clsx(styles.stickyCol, stickyColStyle, styles.summaryCell)}
        {...rest}
      >
        {children}
      </TableCell>
    );
  };

  useEffect(() => {
    if (selectedPlant.label)
      setStylesAccordingToPlant(
        selectedPlant,
        setStyles,
        defaultStyles,
        jlrStyles,
      );
  }, [selectedPlant]);
  
  useEffect(() => {
    if (lines.value) {
      loadShopIdForSelectedLine(lines.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line]);

  const [isAddVcFormOpen, setIsAddVcFormOpen] = useState(false);
  const [isAddVcFormOpenMes4, setIsAddVcFormOpenMes4] = useState(false);

  const openAddVcForm = () => {
    if (
      APPLICATION_VARIANTS.MES4 === APPLICATION_VARIANT ||
      APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT
    ) {
      setIsAddVcFormOpenMes4(true);
      setIsAddVcFormOpen(false);
    } else {
      setIsAddVcFormOpen(true);
    }
  };

  const closeAddVcForm = () => setIsAddVcFormOpen(false);

  const closeAddVcFormMes4 = () => setIsAddVcFormOpenMes4(false);

  const [isAddEmergencyAsnFormOpen, setIsAddEmergencyAsnFormOpen] = useState(
    false,
  );

  const [
    isAddEmergencyAsnFormOpenMes4,
    setIsAddEmergencyAsnFormOpenMes4,
  ] = useState(false);
  const openAddEmergencyAsnForm = () => {
    if (
      APPLICATION_VARIANTS.MES4 === APPLICATION_VARIANT ||
      APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT
    ) {
      setIsAddEmergencyAsnFormOpenMes4(true);
      setIsAddEmergencyAsnFormOpen(false);
    } else {
      setIsAddEmergencyAsnFormOpen(true);
    }
  };
  const closeAddEmergencyAsnForm = () => {
    if (
      APPLICATION_VARIANTS.MES4 === APPLICATION_VARIANT ||
      APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT
    ) {
      setIsAddEmergencyAsnFormOpenMes4(false);
    } else {
      setIsAddEmergencyAsnFormOpen(false);
    }
  };

  const [isSelectAddTypeDialogOpen, setIsSelectAddTypeDialogOpen] = useState(
    false,
  );

  const openSelectAddTypeDialog = () => setIsSelectAddTypeDialogOpen(true);
  const closeSelectAddTypeDialog = () => setIsSelectAddTypeDialogOpen(false);

  const startDate = moment(planData.startDate, DATE_FORMAT.ISO);
  const endDate = moment(planData.endDate, DATE_FORMAT.ISO);
  const dates = getDatesForRange(startDate, endDate);

  const [vcSearchText, setVcSearchText] = useState('');
  const [descriptionSearchText, setDescriptionSearchText] = useState('');

  const [activePage, setActivePage] = useState(0);
  const [rowsData, setRowsData] = useState([...planData.filteredData]);
  const [activeRows, setActiveRows] = useState(
    rowsData.map((row, index) => ({ ...row, index })).slice(0, ROWS_PER_PAGE),
  );
  const [editRowPlanValues, setEditRowPlanValues] = useState({});
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isEditFormOpenMes4, setIsEditFormOpenMes4] = useState(false);
  const editSaveButtonRef = useRef(null);
  const [sortData, setSortData] = useState({
    sortField: null,
    sortState: SORT_STATE.UNSORTED,
  });

  const closeEditForm = () => {
    if (
      APPLICATION_VARIANTS.MES4 === APPLICATION_VARIANT ||
      APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT
    )
      setIsEditFormOpenMes4(false);
    else setIsEditFormOpen(false);
  };

  const openEditForm = () => {
    let isPlanEditHappened = false;
    for (const currentDate in editRowPlanValues) {
      let latest = parseInt(editRowPlanValues[currentDate]);
      let old = rowsData[editActiveRowIndex].plan[currentDate]['quantity'];
      if (latest !== old) {
        isPlanEditHappened = true;
        break;
      }
    }

    if (isPlanEditHappened) {
      if (
        APPLICATION_VARIANTS.MES4 === APPLICATION_VARIANT ||
        APPLICATION_VARIANTS.MES4_EV === APPLICATION_VARIANT
      )
        setIsEditFormOpenMes4(true);
      else setIsEditFormOpen(true);
    } else {
      stopEditing();
    }
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popoverVal, setPopoverVal] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event, val) => {
    if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
      setPopoverVal(val);
      setIsPopupOpen(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = event => {
    setIsPopupOpen(false);
    setAnchorEl(null);
  };

  const closePopup = () => setIsPopupOpen(false);
  const usePopoverStyles = makeStyles(theme => ({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
      color: 'white',
      backgroundColor: 'grey',
      fontSize: '11.8px', //TODO: keep same as table cell
    },
  }));

  const popoverClasses = usePopoverStyles();

  useEffect(() => {
    const startRowValue = activePage * ROWS_PER_PAGE;
    setActiveRows(
      rowsData
        .map((row, index) => ({ ...row, index }))
        .slice(startRowValue, startRowValue + ROWS_PER_PAGE),
    );
  }, [activePage, rowsData]);

  useEffect(() => {
    if (
      editActiveRowIndex !== null &&
      editActiveRowIndex !== undefined &&
      rowsData[editActiveRowIndex]
    ) {
      const plan = { ...rowsData[editActiveRowIndex].plan };
      Object.keys(plan).forEach(date => (plan[date] = plan[date].quantity));
      setEditRowPlanValues({
        ...plan,
      });
    }
  }, [editActiveRowIndex, rowsData]);

  const filterByNestedVcDescriptionCurry = searchText => data =>
    !searchText ||
    data.attributes.description
      .toLowerCase()
      .indexOf(searchText.toLowerCase()) !== -1;

  useEffect(() => {
    const filteredData = [...planData.filteredData]
      .filter(filterByVcCurry(vcSearchText))
      .filter(filterByNestedVcDescriptionCurry(descriptionSearchText));

    setRowsData(filteredData);
    //reset Sort
    setSortData({ sortField: null, sortState: SORT_STATE.UNSORTED });
    //reset to proper page on application of filter if there is no data on current page after filtering
    setActivePage(prevState => {
      const count = filteredData.length;
      const pagesCount = Math.ceil(count / ROWS_PER_PAGE);
      if (prevState + 1 > pagesCount) return 0;
      return prevState || 0;
    });
  }, [descriptionSearchText, planData.filteredData, vcSearchText]);

  const leftTable = useRef(null);
  const rightTable = useRef(null);

  const fixedColumnsStyling = {
    headerStyles: {
      backgroundColor: 'white',
    },
  };
  const fixedColumns = [
    {
      width: 120,
      title: 'VC',
      field: 'vc',
      style: {
        textAlign: 'left',
      },
      headerStyles: { paddingLeft: '2px' },
      render: rowData => (
        <VcWithPartialDataInfo vcData={rowData} lineName={lineName} />
      ),
      renderHeader: () => (
        <>
          <HeaderSearchBar
            title={
              <>
                <AuthEnabledButton
                  operation={USER_OPERATIONS.CREATE_CHASSIS_PLAN_QUANTITY}
                  ButtonComponent={IconButton}
                  isIconButton
                  data-testid="add-to-plan-btn"
                  className={styles.selectFormButton}
                  onClick={callFunctionConditionallyWithWarningCurry(
                    openSelectAddTypeDialog,
                    editActiveRowIndex !== null,
                  )}
                >
                  <AddCircleIcon
                    style={{
                      fontSize: 16,
                      color: plantName === JLR_PLANT ? '#26662E' : '#ffa221',
                    }}
                  />
                </AuthEnabledButton>
                VC
              </>
            }
            handleChange={e => setVcSearchText(e.target.value)}
            clearData={() => setVcSearchText('')}
            placeholder="Search VCs"
            value={vcSearchText}
            iconProps={{ className: styles.searchIcon }}
          />
        </>
      ),
    },
    {
      width: 235,
      title: 'Description',
      field: 'description',
      style: {
        textAlign: 'left',
      },
      renderHeader: () => (
        <>
          <HeaderSearchBar
            title="Description"
            handleChange={e => setDescriptionSearchText(e.target.value)}
            clearData={() => setDescriptionSearchText('')}
            placeholder="Search VC Description"
            value={descriptionSearchText}
            iconProps={{ className: styles.searchIcon }}
          />
        </>
      ),
    },
    {
      width: 90,
      title: 'Target',
      field: 'total',
      sortable: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      width: 100,
      title: 'Balance',
      field: 'balance',
      sortable: true,
      style: {
        textAlign: 'center',
      },
    },
  ].map(column => ({
    ...column,
    ...fixedColumnsStyling,
    headerStyles: {
      ...fixedColumnsStyling.headerStyles,
      ...column.headerStyles,
    },
  }));

  const optionalColumnsStyles = {
    headerStyles: {
      color: '#707070',
      backgroundColor: 'white',
    },
  };
  const selectedOptionalColumns = getSelectedOptionalColumns(
    optionalColumns,
    selectedOptionalCols,
    optionalColumnsStyles,
  );

  const dateColumnsStyling = {};
  const dateColumns = dates.map(date => ({
    field: moment(date).format(DATE_FORMAT.ISO),
    title: moment(date).format('DD'),
    disabled: date.isSameOrBefore(lastAsnGeneratedDate)|| date.isBefore(moment(), 'day'),
    
    isSunday: isSunday(date),
    ...dateColumnsStyling,
  }));

  const columns = [...fixedColumns, ...selectedOptionalColumns];
  const rows = activeRows.map(planData => {
    const { plan, index, attributes, target, ...rest } = planData;
    return { ...rest, index, ...plan, ...attributes, target };
  });

  const monthlyTarget = rowsData.reduce((acc, vc) => acc + vc.total, 0);
  const monthlyBalance = rowsData.reduce((acc, vc) => acc + vc.balance, 0);

  const totalRow = {};
  dateColumns.forEach(dateCol => (totalRow[dateCol.field] = 0));
  rowsData.forEach(row => {
    dateColumns.forEach(dateCol => {
      if (row.plan[dateCol.field]) {
        totalRow[dateCol.field] += row.plan[dateCol.field].quantity;
      }
    });
  });

  const handleEditCancel = () => {
    closeEditForm();
    stopEditing();
  };

  const getEditRowQuantities = () =>
    Object.keys(editRowPlanValues)
      .filter(
        date =>
          !moment(date, DATE_FORMAT.ISO).isSameOrBefore(lastAsnGeneratedDate),
      )
      .map(date => ({
        quantity: editRowPlanValues[date],
        date,
      }));

  const validateEditRowQuantities = () => {
    const values = Object.keys(editRowPlanValues).map(date =>
      String(editRowPlanValues[date]),
    );
    const areValuesValid = values.every(
      value => isPositiveIntegerOrZero(value) && value.length,
    );
    if (!areValuesValid)
      throw new Error(
        DISPLAY_MESSAGES.EDIT_NON_NEGATIVE_NUMBER_VALIDATION_WARNING,
      );
  };

  const validateAndGetEditRowQuantities = () => {
    validateEditRowQuantities();
    return getEditRowQuantities();
  };

  const handleEditSubmit = async ({
    vc,
    category,
    market,
    countryCode,
    fbv,
    defence,
    fbvVendorCode,
    buildCardNumber,
    powerSteering,
    reason,
    agency,
    comment,
    colourCode,
    evrNumber
  }) => {
    try {
      const quantities = validateAndGetEditRowQuantities();
      await API.put(API_RESOURCE_URLS.VC_QUANTITY, {
        plant,
        line,
        vc,
        category,
        market,
        countryCode,
        fbv,
        defence,
        fbvVendorCode,
        buildCardNumber,
        powerSteering,
        quantities,
        reason,
        agency,
        comment,
        colourCode,
        evrNumber,
      });
      closeEditForm();
      stopEditing();
      updateRows();
    } catch (error) {
      console.error(buildErrorMessage(error));
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: 'Plan edit failed.',
        error,
        info: error.message,
      });
    }
  };

  const handleEditSubmitMes4 = async ({ vc, reason, agency, comment }) => {
    try {
      const quantities = validateAndGetEditRowQuantities();
      await API.put(API_RESOURCE_URLS.VC_QUANTITY, {
        plant,
        line,
        vc,
        quantities,
        reason,
        agency,
        comment,
      });
      closeEditForm();
      stopEditing();
      updateRows();
    } catch (error) {
      console.error(buildErrorMessage(error));
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: 'Plan edit failed.',
        error,
        info: error.message,
      });
    }
  };

  const handleEdit = (value, dateString) => {
    if (value && !isPositiveIntegerOrZero(value)) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: DISPLAY_MESSAGES.PLAN_DATA_ERROR,
        info: DISPLAY_MESSAGES.INVALID_NUMBER,
      });
      stopEditing();
    } else if (value && !isQuantityValid(value)) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: DISPLAY_MESSAGES.PLAN_DATA_ERROR,
        info: DISPLAY_MESSAGES.INVALID_QUANTITY,
      });
      stopEditing();
    }

    setEditRowPlanValues(prevState => ({
      ...prevState,
      [dateString]: value,
    }));
  };

  const handleEditBlur = event => {
    if (!event.target.value) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: DISPLAY_MESSAGES.PLAN_DATA_ERROR,
        info: 'Value cannot be empty.',
      });
    }
  };

  const renderTotal = (label, value) => (
    <div>
      <span
        style={{
          fontSize: '9px',
          display: 'block',
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: '12px',
          display: 'block',
        }}
      >
        {value}
      </span>
    </div>
  );

  const getNextSortState = (field, sortData) => {
    const sortStates = [
      SORT_STATE.ASCENDING,
      SORT_STATE.DESCENDING,
      SORT_STATE.UNSORTED,
    ];
    if (field === sortData.sortField) {
      const currentSortState = sortData.sortState;
      const idx = sortStates.indexOf(currentSortState);
      const nextSortStateIdx = (idx + 1) % sortStates.length;
      return sortStates[nextSortStateIdx];
    }
    return sortStates[0];
  };
  const applySort = field => {
    const nextSortState = getNextSortState(field, sortData);
    switch (nextSortState) {
      case SORT_STATE.ASCENDING:
        rowsData.sort((a, b) => a[field] - b[field]);
        setRowsData([...rowsData]);
        break;
      case SORT_STATE.DESCENDING:
        rowsData.sort((a, b) => b[field] - a[field]);
        setRowsData([...rowsData]);
        break;
      case SORT_STATE.UNSORTED:
        setRowsData([
          ...planData.filteredData
            .filter(filterByVcCurry(vcSearchText)) // keep search state
            .filter(filterByNestedVcDescriptionCurry(descriptionSearchText)),
        ]);
        break;
      default:
        //do nothing
        break;
    }
    setSortData({ sortState: nextSortState, sortField: field });
  };

  const skipToLastPage = () =>
    setActivePage(
      Math.max(Math.ceil(planData.filteredData.length / ROWS_PER_PAGE) - 1, 0),
    );

  const renderSortingHeader = col => {
    let sortIcon = (
      <SortAscendingIcon
        style={{ color: '#707070', opacity: '0.5' }}
        className={styles.sortIcon}
      />
    );
    if (sortData.sortField === col.field) {
      if (sortData.sortState === SORT_STATE.ASCENDING) {
        sortIcon = <SortAscendingIcon className={styles.sortIcon} />;
      } else if (sortData.sortState === SORT_STATE.DESCENDING) {
        sortIcon = <SortDescendingIcon className={styles.sortIcon} />;
      }
    }
    return (
      <span onClick={() => applySort(col.field)}>
        {col.title} {sortIcon}
      </span>
    );
  };

  const handleDownloadTemplateButtonClick = () => {
    const link = document.createElement('a');
    if (APPLICATION_VARIANTS.MES4_EV === config.APPLICATION_VARIANT) {
      link.href = 'EVTemplate/Emergency-Bulk-upload-plan-template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  const handleEmergencyFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "",
    });
    const lastsequenceddate = lastAsnGeneratedDate.format('YYYY-MM-DD');
    let validationError = false;
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    const transformedData = jsonData
      .slice(1)
      .map((row) => {
        if (
          row.every(
            (value) => value === "" || value === null || value === undefined
          )
        ) {
          return null;
        }
        if (row[0] === "" || row[1] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_PLANT_LINE_MISSING,
            info: "Plant or line value is missing",
          });
          validationError = true;
          return null;
        } else if (row[2] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_VC_MISSING,
            info: "VC Number is missing",
          });
          validationError = true;
          return null;
        } else if (row[3] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_ADDITIONAL_QUANTITY_MISSING,
            info: "Additional Quantity is missing",
          });
          validationError = true;
          return null;
        } else if (row[4] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_REASON_MISSING,
            info: "Failed! Reason is missing. Reason: A valid reason for the emergency plan change was not provided. How to proceed: Please select or enter a reason before uploading",
          });
          validationError = true;
          return null;
        } else if (row[5] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_AGENCY_MISSING,
            info: "Agency is missing",
          });
          validationError = true;
          return null;
        } else if (row[6] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_DATE_MISSING,
            info: "Failed! Plan date is missing. Reason: The production date was not entered during the emergency plan upload. How to proceed: Please enter the production date to proceed with the upload",
          });
          validationError = true;
          return null;
        }else if (new Date(row[6]) > new Date(lastsequenceddate)) {
          showError({
              contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_DATE_FORMAT_CHANGE,
              info: "Failed! Invalid plan date. Reason: The plan date cannot be later than the last frozen sequence date. How to proceed: Please select a valid date within the allowed range",
          });
          validationError = true;
          return null;
      }
        else if (!dateRegex.test(row[6])) {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_DATE_FORMAT_INVALID,
            info: "Failed! Invalid date format. Reason: The date entered is not in the required format (yyyy-mm-dd). How to proceed: Please enter the date in the correct format, e.g., 2025-09-10.",
          });
          validationError = true;
          return null;
        } 
        else if (row[7] === "") {
          showError({
            contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_SHOP_MISSING,
            info: "Shop ID value is missing",
          });
          validationError = true;
          return null;
        } else {
          return {
            plant: row[0],
            line: row[1],
            vc: row[2],
            additionalQuantity: row[3],
            reason: row[4],
            agency: row[5],
            planDate: row[6],
            shop: row[7],
            comment: "",
          };
        }
      })
      .filter(Boolean);

    if (!validationError) {
      setFileData(transformedData);
      setIsDialogOpen(true);
      setFileName(file.name);
    }
  };
  const handleConfirm = async () => {
    setIsDialogOpen(false);
    try {
      showLoading();
      await API.patch(
        API_RESOURCE_URLS.emergencybulkupload(
          plant,
          line,
          shopId
        ),
        fileData
      );
      const totalRowsUploaded = fileData.length;
      showPopup({
        info: `Total ${totalRowsUploaded} Quantity Uploaded \n File Name: ${FileName}`,
        type: MESSAGE_TYPE.SUCCESS,
        contextText: DISPLAY_MESSAGES.EMERGENCY_PLAN_UPLOAD_SUCCESS,
      });
    } catch (error) {
      console.error("Error 400");
      const errorMessage = error.response.data.errors.join("");
      showError({
        contextText: errorMessage,
        info: "",
      });
    }
  };


  return (
    <div style={{ width: '100%', backgroundColor: 'white' }}>
      <TableContainer
        className={styles.attributesTable}
        onScroll={e => {
          rightTable.current.scrollTop = e.target.scrollTop;
        }}
        ref={leftTable}
      >
        <Table stickyHeader className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {columns.map((col, idx) => (
                <TableCell
                  className={clsx(
                    idx < fixedColumns.length && styles.stickyCol,
                    idx < fixedColumns.length && getStickyStyle(idx),
                    styles.mightOverflow,
                    styles.mTablecellBold,
                  )}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    ...col.style,
                    ...col.headerStyles,
                  }}
                  key={idx}
                >
                  {col.sortable
                    ? renderSortingHeader(col)
                    : (col.renderHeader && col.renderHeader()) || col.title}
                </TableCell>
              ))}
              {/* dummy col to always show 'Daily plan' label in summary row */}
              {selectedOptionalColumns.length === 0 && (
                <TableCell className={styles.mTablecellBold} />
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow className={styles.mTableRow} key={row.index}>
                {columns.map((col, idx) => (
                  <TableCell
                    className={clsx(
                      idx < fixedColumns.length && styles.stickyCol,
                      idx < fixedColumns.length && getStickyStyle(idx),
                      styles.mightOverflow,
                      styles.mTablecell,
                    )}
                    style={{
                      width: col.width,
                      minWidth: col.width,
                      maxWidth: col.width,
                      ...col.style,
                      ...col.cellStyles,
                    }}
                    key={idx}
                    onMouseEnter={e => handlePopoverOpen(e, row[col.field])}
                    onMouseLeave={e => handlePopoverClose(e)}
                  >
                    {col.render ? col.render(row) : row[col.field]}
                  </TableCell>
                ))}
                {/* dummy col to always show 'Daily Plan' data label in summary row */}
                {selectedOptionalColumns.length === 0 && (
                  <TableCell className={styles.mTablecell} />
                )}
              </TableRow>
            ))}
            <TableRow className={styles.summaryRow}>
              <SummaryCell colNo={0}>Total</SummaryCell>
              <SummaryCell colNo={1} />
              <SummaryCell colNo={2} style={{ textAlign: 'center' }}>
                {renderTotal('Monthly Target', monthlyTarget)}
              </SummaryCell>
              <SummaryCell colNo={3} style={{ textAlign: 'center' }}>
                {renderTotal('Monthly Balance', monthlyBalance)}
              </SummaryCell>
              <TableCell
                className={styles.summaryCell}
                colSpan="100"
                align="right"
              >
                Daily Plan
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer
        className={styles.datesTable}
        ref={rightTable}
        onScroll={e => (leftTable.current.scrollTop = e.target.scrollTop)}
      >
        <Table className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {dateColumns.map((date, idx) => (
                <TableCell
                  className={clsx(
                    styles.mTablecellTitle,
                    date.disabled && styles.disabledCell,
                    date.isSunday && styles.sundayCell,
                  )}
                  key={idx}
                >
                  {date.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow>
                {dateColumns.map(date => {
                  const dateString = date.field;

                  if (
                    row.index === editActiveRowIndex &&
                    row[dateString] &&
                    !date.disabled
                  )
                    return (
                      <TableCell className={styles.mTablecellInput}>
                        <input
                          style={{
                            width: '54px',
                            height: '37px',
                            padding: '0 0.2em',
                            boxSizing: 'border-box',
                            textAlign: 'center',
                          }}
                          value={editRowPlanValues[dateString]}
                          onChange={e => handleEdit(e.target.value, dateString)}
                          onBlur={handleEditBlur}
                          aria-label={`plan-input-for-${dateString}`}
                        />
                      </TableCell>
                    );
                  return (
                    <TableCell
                      className={clsx(
                        getCellStyle(
                          date.disabled,
                          row[dateString] && row[dateString].edited,
                          date.isSunday,
                          styles,
                        ),
                      )}
                    >
                      {row[dateString] && row[dateString].quantity}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
            <TableRow className={styles.summaryRow}>
              {dateColumns.map(dateCol => (
                <TableCell
                  className={
                    dateCol.disabled
                      ? clsx(styles.disabledCell, styles.summaryCell)
                      : styles.summaryCell
                  }
                  key={dateCol.field}
                >
                  {totalRow[dateCol.field] || null}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div className={styles.editPane}>
        <div className={styles.editColumn}>
          <div className={styles.editHeader}>Edit</div>
          {activeRows.map(({ vc, index }) => (
            <div className={styles.editButton} style={{ overflow: 'hidden' }}>
              {index === editActiveRowIndex ? (
                <>
                  <Icon
                    onClick={() => openEditForm()}
                    ref={editSaveButtonRef}
                    className={styles.saveIcon}
                    data-testid="save-edit"
                  >
                    <img
                      src={
                        plantName === JLR_PLANT
                          ? SaveFloppyGreenSvg
                          : SaveFloppySvg
                      }
                      alt="save-edit"
                      className={styles.saveIconImage}
                    />
                  </Icon>

                  <Icon
                    onClick={() => stopEditing()}
                    ref={editSaveButtonRef}
                    className={styles.cancelIcon}
                  >
                    <img
                      src={CloseSvg}
                      alt="Cancel"
                      onClick={() => stopEditing()}
                      className={styles.cancelIconImage}
                    />
                  </Icon>
                </>
              ) : (
                <AuthEnabledButton
                  operation={USER_OPERATIONS.UPDATE_CHASSIS_PLAN_QUANTITY}
                  isIconButton
                  data-testid={`edit-button-${index}-for-${vc}`}
                  onClick={() => startEditing(index)}
                  className={clsx(styles.editIcon)}
                >
                  <EditIcon style={{ fontSize: 20 }} />
                </AuthEnabledButton>
              )}
            </div>
          ))}
        </div>
      </div>
      <TablePagination
        onChangePage={(e, page) => setActivePage(page)}
        rowsPerPageOptions={[ROWS_PER_PAGE]}
        page={activePage}
        count={rowsData && rowsData.length}
        rowsPerPage={ROWS_PER_PAGE}
        labelDisplayedRows={({ count }) => {
          return `Page ${activePage + 1} of ${Math.ceil(
            count / ROWS_PER_PAGE,
          )}`;
        }}
      />
      <CommentForm
        title="Plan Revision"
        open={isEditFormOpen}
        anchorEl={editSaveButtonRef.current}
        handleClose={closeEditForm}
        handleCancel={handleEditCancel}
        handleSubmit={handleEditSubmit}
        rowData={rowsData[editActiveRowIndex]}
      />

      <CommentFormMes4
        title="Plan Revision"
        open={isEditFormOpenMes4}
        anchorEl={editSaveButtonRef.current}
        handleClose={closeEditForm}
        handleCancel={handleEditCancel}
        handleSubmit={handleEditSubmitMes4}
        rowData={rowsData[editActiveRowIndex]}
      />

      <Popover
        open={isPopupOpen}
        anchorEl={anchorEl}
        onClose={closePopup}
        className={popoverClasses.popover}
        classes={{
          paper: popoverClasses.paper,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {popoverVal}
      </Popover>
      <AddVcFormMes4
        title="Plan Revision: Add VC"
        open={isAddVcFormOpenMes4}
        handleClose={closeAddVcFormMes4}
        vcPlanData={planData.data}
        updatePlanRows={updateRows}
        lastAsnGeneratedDate={lastAsnGeneratedDate}
        skipToLastPage={skipToLastPage}
        cancelButtonText="CANCEL"
        submitButtonText="SUBMIT"
        lineBackgroundColor="#26662E"
        plant={plant}
        plantName={plantName}
        line={line}
        lineName={lineName}
      />
      <AddVcForm
        open={isAddVcFormOpen}
        handleClose={closeAddVcForm}
        vcPlanData={planData.data}
        updatePlanRows={updateRows}
        lastAsnGeneratedDate={lastAsnGeneratedDate}
        skipToLastPage={skipToLastPage}
        plant={plant}
        plantName={plantName}
        line={line}
        lineName={lineName}
      />
      <AddEmergencyAsnFormMes4
        title="Plan Revision: Add ASNs"
        open={isAddEmergencyAsnFormOpenMes4}
        handleClose={closeAddEmergencyAsnForm}
        vcPlanData={planData.data}
        updatePlanRows={updateRows}
        lastAsnGeneratedDate={lastAsnGeneratedDate}
        skipToLastPage={skipToLastPage}
        cancelButtonText="CANCEL"
        submitButtonText="SUBMIT"
        lineBackgroundColor="#F2A75E"
        plant={plant}
        plantName={plantName}
        line={line}
        lineName={lineName}
      />
      <AddEmergencyAsnForm
        open={isAddEmergencyAsnFormOpen}
        handleClose={closeAddEmergencyAsnForm}
        vcPlanData={planData.data}
        updatePlanRows={updateRows}
        lastAsnGeneratedDate={lastAsnGeneratedDate}
        skipToLastPage={skipToLastPage}
        plant={plant}
        plantName={plantName}
        line={line}
        lineName={lineName}
      />
      <SelectAddTypeDialog
        open={isSelectAddTypeDialogOpen}
        handleClose={closeSelectAddTypeDialog}
        openAddVcForm={openAddVcForm}
        openAddEmergencyAsnForm={openAddEmergencyAsnForm}
        lastAsnGeneratedDate={lastAsnGeneratedDate}
      />
      <EmergencyWarningDialog
      open={isDialogOpen}
      onCancel={() => setIsDialogOpen(false)}
      onConfirm={handleConfirm}
      />
    </div>
  );
};

DayWisePlanDataTable.propTypes = {
  planData: PropTypes.object.isRequired,
  optionalColumns: PropTypes.array,
  selectedOptionalCols: PropTypes.array,
  startEditing: PropTypes.func,
  editActiveRowIndex: PropTypes.number,
  stopEditing: PropTypes.func,
  lastAsnGeneratedDate: PropTypes.objectOf(moment).isRequired,
  plant: PropTypes.string.isRequired,
  plantName: PropTypes.string.isRequired,
  line: PropTypes.string.isRequired,
  lineName: PropTypes.string.isRequired,
};

export default DayWisePlanDataTable;
